module.exports = __webpack_public_path__ + "img/logo2.c1c5a611.png";